import styled from 'styled-components';
import { Props } from './types';

export const SIZES = {
  // XXSMALL: 20,
  // XSMALL: 30,
  SMALL: 40,
  MEDIUM: 50,
  // LARGE: 60,
  // XLARGE: 70,
  // XXLARGE: 80,
};

type T = Pick<Props, 'palette'>;

export const Root = styled.label<T>`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 10px;
  cursor: pointer;

  & .checkbox {
    width: 20px;
    height: 20px;
    display: block;
    border-radius: 2px;
    position: relative;
    overflow: hidden;

    & .checkbox-input {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: block;
      height: 100%;
      width: 100%;
      margin: 0;
      padding: 0;
      opacity: 0;
    }

    & .checkbox-inner {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: block;
      height: 100%;
      width: 100%;
      border: 2px solid #2c2c2c;
      transition: background 0.2s ease-in;

      border-color: ${({ palette }) => {
        switch (palette) {
          case 'primary': {
            return '#ea475c';
          }
          default: {
            return '#292929';
          }
        }
      }};
    }

    &.checkbox-checked {
      & .checkbox-inner {
        background: #2c2c2c;

        &:after {
          // eslint-disable-next-line max-len
          content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' aria-hidden='true'%3E%3Cpath fill='%23fff' d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z'%3E%3C/path%3E%3C/svg%3E");
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
        }
      }
    }

    &.checkbox-indeterminate {
      & .checkbox-inner {
        background: #2c2c2c;
        opacity: 0.8;

        &:after {
          // eslint-disable-next-line max-len
          content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' aria-hidden='true'%3E%3Cpath fill='%23fff' d='M19 13H5v-2h14v2z'%3E%3C/path%3E%3C/svg%3E");
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
        }
      }
    }
  }
`;
